export const gemeenten = state => state.gemeenten;
export const settings = state => state.settings;
